"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharkMorphProvider = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var React = __importStar(require("react"));
var SharkMorphContext_1 = require("./SharkMorphContext");
var SharkMorphProvider = function (_a) {
    var debug = _a.debug, theme = _a.theme, children = _a.children, prop = __rest(_a, ["debug", "theme", "children"]);
    React.useEffect(function () {
        switch (prop.application) {
            case 'webApp': {
                var divShark = document.getElementsByClassName('shark')[0];
                divShark.setAttribute('data-theme', theme);
                break;
            }
            case 'webComponent': {
                var webComponent = document.querySelector(prop.tag);
                var shadowRoot = webComponent === null || webComponent === void 0 ? void 0 : webComponent.shadowRoot;
                var shadowShark = shadowRoot === null || shadowRoot === void 0 ? void 0 : shadowRoot.querySelector('.shark');
                shadowShark === null || shadowShark === void 0 ? void 0 : shadowShark.setAttribute('data-theme', theme);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [theme]);
    return ((0, jsx_runtime_1.jsx)(SharkMorphContext_1.SharkMorphContext.Provider, __assign({ value: __assign({ debug: debug, theme: theme }, (prop.application === 'webApp'
            ? { application: 'webApp' }
            : { application: 'webComponent', tag: prop.tag })) }, { children: children })));
};
exports.SharkMorphProvider = SharkMorphProvider;
//# sourceMappingURL=SharkMorphProvider.js.map